import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { LinkFilterComponent } from '@ftr/ui-annotations'
import { SharedAuthRoutesModule } from '@ftr/ui-auth-routes'
import { RedirectSitePortalToHomeIfPublicNavigationGuard } from '@ftr/ui-user'

@NgModule({
  imports: [
    SharedAuthRoutesModule,
    LinkFilterComponent,
    RouterModule.forChild([
      {
        path: AppPaths.LinkFilter,
        component: LinkFilterComponent,
        data: {
          hideSideNav: true,
          noWrapper: true,
        },
      },
      {
        path: AppPaths.CourtroomDisplay,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        loadChildren: () =>
          import('./courtroom-display/courtroom-display.module').then(m => m.CourtroomDisplayPageModule),
      },
      {
        path: AppPaths.CourtroomJoin,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        loadChildren: () =>
          import('./courtroom-join/public-courtroom-join.module').then(m => m.PublicCourtroomJoinPageModule),
      },
      {
        path: AppPaths.CourtroomJoinDetail,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        loadChildren: () =>
          import('./courtroom-join-detail/public-courtroom-join-detail.module').then(
            m => m.PublicCourtroomJoinDetailPageModule,
          ),
      },
      {
        path: AppPaths.StandaloneAppDownload,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        loadChildren: () => import('./standalone-apps/standalone-apps.module').then(m => m.StandaloneAppsPageModule),
      },
    ]),
  ],
  exports: [RouterModule],
})
export class RootModule {}
